import styled, { css } from 'styled-components';

export const SotyBadge = styled.div`
  display: flex;
  justify-content: center;
`;

type ImageWrapperProps = {
  size: number;
};

export const ImageWrapper = styled.div<ImageWrapperProps>(
  props => css`
    width: ${`${props.size}px`};
  `
);
